import type {Article} from '../domain/types';

export function SourceArchiveDetails({article}:{article:Article}){
 const versions=article.sourceVersions||[];
 return <>
  {article.author&&<p>Tác giả theo nguồn: {article.author}</p>}
  {versions.some(source=>source.unavailableFragments?.length)&&<p>Một phần nội dung nguồn chưa truy cập được.</p>}
  {versions.length>0&&<details><summary>Các bản nội dung theo từng nguồn ({versions.length})</summary>{versions.map((source,i)=><section key={source.url+'-'+i} lang={/\/en\//.test(source.url)?'en':undefined}><h3>{source.title}</h3><a href={source.url} target="_blank" rel="noopener noreferrer">Xem nguồn</a>{source.date&&<p>{source.date}</p>}{source.author&&<p>{source.author}</p>}<p style={{whiteSpace:'pre-wrap'}}>{source.text}</p></section>)}</details>}
  {!!article.videos?.length&&<ul aria-label="Liên kết video nguồn">{article.videos.map(url=><li key={url}><a href={url} target="_blank" rel="noopener noreferrer">{url}</a></li>)}</ul>}
 </>;
}
